import { render } from "./CorrectionDiff.vue?vue&type=template&id=ca0b26ea&scoped=true"
import script from "./CorrectionDiff.vue?vue&type=script&lang=js"
export * from "./CorrectionDiff.vue?vue&type=script&lang=js"

import "./CorrectionDiff.vue?vue&type=style&index=0&id=ca0b26ea&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca0b26ea"]])

export default __exports__